import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import { Layout } from './components/layout/Layout';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { PublicOnlyRoute } from './components/auth/PublicOnlyRoute';
import { StagingGuard } from './components/auth/StagingGuard';
import { ScrollToTop } from './components/ScrollToTop';

// Pages
import { HomePage } from './pages/HomePage';
import { DiscoverV2 } from './pages/DiscoverV2';
import { PricingPage } from './pages/PricingPage';
import { BrowseCoursesPage } from './pages/BrowseCoursesPage';
import { LoginPage } from './pages/auth/LoginPage';
import { RegisterPage } from './pages/auth/RegisterPage';
import { DashboardPage } from './pages/DashboardPage';
import { CoursesPage } from './pages/CoursesPage';
import CourseDetailPage from './pages/CourseDetailPage';
import { LessonPage } from './pages/LessonPage';
import { QuizPage } from './pages/QuizPage';
import { GeneratePage } from './pages/GeneratePage';
import { TryGeneratePage } from './pages/TryGeneratePage';
import { ProfilePage } from './pages/ProfilePage';
import { UpgradePage } from './pages/UpgradePage';
import { ContactPage } from './pages/ContactPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { WhyAIUniversityPage } from './pages/WhyAIUniversityPage';

function App() {
  return (
    <AuthProvider>
      <SubscriptionProvider>
        <StagingGuard>
          <Layout>
            <ScrollToTop />
            <Routes>
            {/* Public routes - redirect authenticated users */}
            <Route
              path="/"
              element={
                <PublicOnlyRoute>
                  <HomePage />
                </PublicOnlyRoute>
              }
            />
            <Route
              path="/discover-v2"
              element={
                <PublicOnlyRoute>
                  <DiscoverV2 />
                </PublicOnlyRoute>
              }
            />
            <Route
              path="/pricing"
              element={
                <PublicOnlyRoute>
                  <PricingPage />
                </PublicOnlyRoute>
              }
            />
            <Route
              path="/why-ai-university"
              element={
                <PublicOnlyRoute>
                  <WhyAIUniversityPage />
                </PublicOnlyRoute>
              }
            />
            <Route
              path="/explore"
              element={
                <PublicOnlyRoute>
                  <BrowseCoursesPage />
                </PublicOnlyRoute>
              }
            />
            <Route
              path="/try-generate"
              element={
                <PublicOnlyRoute>
                  <TryGeneratePage />
                </PublicOnlyRoute>
              }
            />
            <Route
              path="/login"
              element={
                <PublicOnlyRoute>
                  <LoginPage />
                </PublicOnlyRoute>
              }
            />
            <Route
              path="/register"
              element={
                <PublicOnlyRoute>
                  <RegisterPage />
                </PublicOnlyRoute>
              }
            />
            <Route path="/browse" element={<BrowseCoursesPage />} />
            <Route path="/courses" element={<CoursesPage />} />
            <Route
              path="/my-courses"
              element={
                <ProtectedRoute>
                  <CoursesPage />
                </ProtectedRoute>
              }
            />
            <Route path="/courses/:id" element={<CourseDetailPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />

            {/* Protected routes */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/generate"
              element={
                <ProtectedRoute>
                  <GeneratePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lessons/:id"
              element={
                <ProtectedRoute>
                  <LessonPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/quizzes/:id"
              element={
                <ProtectedRoute>
                  <QuizPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile/billing"
              element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile/security"
              element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/upgrade-plan"
              element={
                <ProtectedRoute>
                  <UpgradePage />
                </ProtectedRoute>
              }
            />

            {/* Catch all */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Layout>
        </StagingGuard>
      </SubscriptionProvider>
    </AuthProvider>
  );
}

export default App;
